'use client'

import { DigitalData } from "@dustin-web/microsite-components/src/utils/digital-data"

export const sendFeatureFlagToGTM = (featureFlag: string, ruleKey: string, variationKey: string) => {
  if (typeof window === 'undefined') {
    return
  }

  const events = window?.DigitalData as Record<string, unknown>[]

  const eventAlreadyPushed = events?.find((event) =>
    event?.event === 'optimizely-decision' && event?.['optimizely-flagKey'] === featureFlag
  )

  if (eventAlreadyPushed) {
    return
  }

  const event = {
    event: 'optimizely-decision',
    'optimizely-flagKey': featureFlag,
    'optimizely-ruleKey': ruleKey,
    'optimizely-variationKey': variationKey,
  }

  DigitalData.pushEvent(event)
}
